// extracted by mini-css-extract-plugin
module.exports = {"item":"DashboardBanner__item","itemImage":"DashboardBanner__itemImage","image":"DashboardBanner__image"};